import { Controller } from '@hotwired/stimulus';
import CurrentUser from '@frontend/app/features/CurrentUser';
import { loadAndDisplay as loadAndDisplayInModal } from '@controllers/main/modal-window_controller';

export default class extends Controller {
  static values = {
    shareModalUrl: String,
    hasPaywall: Boolean,
  };

  connect() {
    if (!this.hasPaywallValue || !CurrentUser.isSubscriber()) return false;
    if (CurrentUser.isAdmin() || CurrentUser.isEditor()) return false;

    this.element.dataset.ready = 'true';
  }

  showShareUrlModal() {
    loadAndDisplayInModal(this.shareModalUrlValue);
  }
}
